import { useLang } from "@/lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  return (
    <div className="marquee" aria-label="Service highlights" data-testid="marquee-strip">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div className="marquee-group" key={copy} aria-hidden={copy === 1}>
            {t.marquee.map((item) => (
              <span className="marquee-item" key={`${copy}-${item}`}>
                {item} <i>✦</i>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
